import React from "react";
import { Controller } from "react-hook-form";
import ClayRadio from "@clayui/form/lib/Radio";
import ClayRadioGroup from "@clayui/form/lib/RadioGroup";
import BaseWrapper from "../BaseWrapper";

type Option = {
    label: string;
    value: string | number;
};

type FormInputRadioProps = {
    name: string;
    label?: string;
    options: Option[];
    required?: boolean;
    groupClassName?: string;
    disabled?: boolean;
};

export function FormInputRadio(props: FormInputRadioProps) {
    return (
        <Controller
            name={props.name}
            render={({ field, fieldState }) => (
                <BaseWrapper
                    error={fieldState?.error?.message}
                    id={props.name}
                    label={props.label}
                    required={props.required}
                    groupClassName={props.groupClassName}
                >
                    <ClayRadioGroup
                        id={props.name}
                        onChange={field.onChange}
                        value={field.value}
                    >
                        {props.options.map((option) => (
                            <ClayRadio
                                key={option.value}
                                label={option.label}
                                value={option.value}
                                disabled={props.disabled}
                                required={props.required}
                            />
                        ))}
                    </ClayRadioGroup>
                </BaseWrapper>
            )}
        />
    );
}
